"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./Styles.scss");
var _Progress = _interopRequireDefault(require("../../../App/Shared/Components/Progress/Progress"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LoadingOverlay = function LoadingOverlay(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'loadingoverlay ' + (props.show ? 'show' : 'hide'),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react["default"].createElement(_Progress["default"], {
    loading: props.show
  }));
};
var _default = exports["default"] = LoadingOverlay;